import React from 'react';
import { Helmet } from 'react-helmet-async';

const Favorites = () => {
  return (
    <>
      <Helmet>
        <title>Favoritos - Cerveja Delivery</title>
      </Helmet>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <h2 className="text-xl font-bold text-dark-900 mb-4">Meus Favoritos</h2>
        <div className="text-center py-12 text-dark-500">
          <p>Você ainda não favoritou nenhuma cervejaria.</p>
        </div>
      </div>
    </>
  );
};

export default Favorites;